import { render, staticRenderFns } from "./DocumentCategory.vue?vue&type=template&id=77d8c790&scoped=true&"
import script from "./DocumentCategory.vue?vue&type=script&lang=js&"
export * from "./DocumentCategory.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCategory.vue?vue&type=style&index=0&id=77d8c790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8c790",
  null
  
)

export default component.exports